import LySummaryPanel from './src/index.vue'

LySummaryPanel.install = function (Vue) {
    Vue.component(LySummaryPanel.name, LySummaryPanel)
}

export default LySummaryPanel



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/summary-panel/index.js
// module id = null
// module chunks = 